import { jsx as _jsx } from "react/jsx-runtime";
import { DEFAULT_CZECH_PHONE_NUMBER_PREFIX, PhoneNumberComboboxInput, } from '@bos/ui';
import { useController } from 'react-hook-form';
import { getPhoneNumberErrorMessage } from './getPhoneNumberErrorMessage';
export const PhoneNumberComboboxField = ({ control, name, registerOptions, defaultPhonePrefix = DEFAULT_CZECH_PHONE_NUMBER_PREFIX, ...props }) => {
    const controller = useController({
        control,
        name,
        rules: registerOptions,
    });
    const handleValueChange = (value, prefix) => {
        if (value || prefix) {
            controller.field.onChange({ ...controller.field.value, value, prefix });
        }
    };
    const phoneNumberErrorMessage = getPhoneNumberErrorMessage(controller.fieldState.error);
    const phoneNumberWithoutPrefix = controller.field.value?.value;
    const phonePrefix = controller.field.value?.prefix ?? defaultPhonePrefix;
    return (_jsx(PhoneNumberComboboxInput, { ...props, ref: controller.field.ref, name: name, error: phoneNumberErrorMessage, phoneNumberWithoutPrefix: phoneNumberWithoutPrefix, phonePrefix: phonePrefix, onValueChange: handleValueChange }));
};
